export const RECENT_DASHBOARDS_PRORITY = 4;
export const DEFAULT_PRIORITY = 3;
export const PREFERENCES_PRIORITY = 2;
export const SEARCH_RESULTS_PRORITY = 1; // Dynamic actions should be below static ones so the list doesn't 'jump' when they come in
